<footer>
  <div class="footer-navigation">
    <nav class="footer-navigation-col">
      <h3>
        <ui-icon faName="circle-question" faStyle="light" title="Alle Services" />
        {{ navServices().title }}
      </h3>
      <h4>{{ navServices().description }}</h4>
      <ul>
        @for (item of navServices().children; track item) {
          <li>
            <a uiNavLink [link]="item">{{ item.label }}</a>
          </li>
        }
      </ul>
    </nav>
    <nav class="footer-navigation-col">
      <h3>
        <ui-icon faName="headset" faStyle="light" title="Alle Kontaktmöglichkeiten" />
        Digital Support
      </h3>
      <h4>Alle Kontaktmöglichkeiten</h4>
      <ul>
        @for (item of navContacts().children; track item) {
          <li>
            <a uiLink link="{{ item.url }}">{{ item.label }}</a>
          </li>
        }
      </ul>
    </nav>
    @if (authorized() && isBmiCustomer()) {
      <div class="footer-navigation-col">
        <h3>
          <ui-icon faName="lightbulb-on" faStyle="light" title="Alle Features" />
          {{ navFeatures().title }}
        </h3>
        <h4>{{ navFeatures().description }}</h4>
        <ul>
          @for (item of navFeatures().children; track item) {
            <li>
              @if (item.label !== 'Warenverfügbarkeit') {
                <a uiNavLink [link]="item">{{ item.label }}</a>
              } @else {
                <span (click)="openProductAvailabilityInfo()" class="link">{{ item.label }}</span>
              }
            </li>
          }
        </ul>
      </div>
      <div class="footer-navigation-col">
        <h3>
          <ui-icon faName="whatsapp" faStyle="brands" title="Exklusive Angebote" />
          Newsletter
        </h3>
        <h4>Exklusive Angebote</h4>
        <p>Sei immer up to date und sichere Dir die besten Deals per WhatsApp!</p>
        <ui-button (click)="openNewsletter()" buttonStyle="outlined">Hier kostenlos anmelden</ui-button>
      </div>
    }
  </div>
  <div class="sub-footer">
    <nav class="legal-pages">
      <ul>
        @for (item of navLegal().children; track item) {
          <li>
            <a mat-button uiNavLink [link]="item">{{ item.label }}</a>
          </li>
        }
      </ul>
    </nav>
    @if (!isCapacitorApp()) {
      <nav class="app-navigation">
        <h3>{{ navLekkerlandApp().title }}</h3>
        <ul>
          @for (item of navLekkerlandApp().children; track item) {
            <li>
              @if (item.url) {
                <a class="app-link" uiNavLink [link]="item">
                  <img [src]="item.image?.src" [alt]="item.image?.alt">
                </a>
              } @else {
                <img [src]="item.image?.src" [alt]="item.image?.alt" class="qr-code">
              }
            </li>
          }
        </ul>
      </nav>
    }
  </div>
  <div class="copyright-wrapper">
    <p class="copyright-note">&copy; Lekkerland {{ currentYear }}</p>
    <span class="version">
        @if (appVersion()) {
          Version: {{ appVersion() }}
        }
      </span>
  </div>

  <div class="bio-certification-wrapper">
    <img [src]="'/assets/img/footer/bio-certification-logo.svg' | formatAbsolute" alt="Bio Certification Logo" />

    <span>Bio-Zertifizierung DE-ÖKO-006</span>
  </div>
</footer>
